import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -90px 0 0 -90px;

  .circle {
    position: absolute;
    border: 3px solid transparent;
    border-top-color: #ffdc00;
    border-radius: 50%;
    animation: rotate linear infinite;
  }
  .circle.one {
    height: 50px;
    width: 50px;
    left: 50px;
    top: 50px;
    animation-duration: 0.85s;
  }
  .circle.two {
    height: 75px;
    width: 75px;
    top: 38px;
    left: 38px;
    animation-duration: 0.95s;
  }
  .circle.three {
    height: 100px;
    width: 100px;
    top: 25px;
    left: 25px;
    animation-duration: 1.05s;
  }

  @keyframes rotate {
    from {
      transform: rotateZ(0deg);
    }
    to {
      transform: rotateZ(360deg);
    }
  }
`

const Loader = () => (
  <Container>
    <div className="circle one" />
    <div className="circle two" />
    <div className="circle three" />
  </Container>
)

export default Loader
